import {useEffect, useRef} from "react";

import {SchedulePolicy, useInterval} from "@khanacademy/wonder-blocks-timing";
import {GuideStateApi, useGuideState} from "@repo/guide-state";

/**
 * Starts a countdown whenever a retryTimeoutSeconds value is set.
 *
 * This hook creates a side-effect in response to a retryTimeoutSeconds value
 * being set. Once a retryTimeoutSeconds value has been set, it updates the
 * decrements value in 1000ms intervals until it reaches 0.
 */
export function useRetryTimeoutSideEffect(): void {
    const retryTimeoutSeconds = useGuideState("retryTimeoutSeconds");
    const prevRetryTimeoutSecondsRef = useRef(retryTimeoutSeconds);
    const countdown = useInterval(
        () => {
            GuideStateApi.set(
                "retryTimeoutSeconds",
                (previous) => previous - 1,
            );
        },
        1000,
        {schedulePolicy: SchedulePolicy.OnDemand},
    );

    useEffect(() => {
        if (
            prevRetryTimeoutSecondsRef.current === 0 &&
            retryTimeoutSeconds > 0
        ) {
            countdown.set();
        } else if (retryTimeoutSeconds <= 0) {
            countdown.clear();
        }
    }, [countdown, retryTimeoutSeconds]);
}
